import React, { Component } from "react";
import "./index.css";

//Import internal components
import AppContext from "../appContext";
import Back from "../main/back";

//Import external components
import MenuHorizontal from "../components/menu/menu-horizontal/index.js";
import { Redirect } from "react-router-dom";
import { get_user_sentForReview_true } from "../Functions/usuario/get-users-sentForReview-true.js";
import Reprovados from "../gestao-cadastro/tabelas/reprovados.js";
import Aprovados from "../gestao-cadastro/tabelas/aprovados.js";
import Pendente from "../gestao-cadastro/tabelas/pendente.js";

class GestaoCadastro extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.childRefs = [];
    this.state = {
      selected_option: 1,
      redirectL: false,
      redirect: false,
      dados: null,
      isLoading: true,
    };

    this.warningFather = this.warningFather.bind(this);
    if (sessionStorage.getItem("token") === null) {
      this.state = { redirectL: true };
    }
  }

  async componentDidMount() {
    if (this.state.redirectL) {
      return;
    }

    if (!this.context?.userSession) {
      this.setState({ redirectL: true });
      return;
    }

    const modulos = this.context.userSession.modulos || [];
    if (!modulos.includes("Gestão de Cadastro")) {
      this.setState({ redirect: true });
      return;
    }

    if (this.context && this.context.showLoading) {
      this.context.showLoading();
    }
    try {
      const result = await get_user_sentForReview_true();
      this.setState({ dados: result, isLoading: false });
    } catch (error) {
      console.error("Erro ao buscar dados da API:", error);
      this.setState({ isLoading: false, dados: null });
    } finally {
      if (this.context && this.context.hideLoading) {
        this.context.hideLoading();
      }
    }
  }

  warningFather(option) {
    if (this.state.selected_option !== option) {
      this.setState({ selected_option: option });
    }
  }

  handleCadastroAnalisado = (cadastro, status) => {
    this.setState(prevState => {
      const dados = prevState.dados || {};
      const usuarioId = cadastro?.usuario?.Id;
      const destino = status === "APROVADO" ? "aprovado" : "reprovado";
      const original = (dados.pendente_aprovacao || []).find(item => item?.usuario?.Id === usuarioId);
      const analisado = {
        ...cadastro,
        usuario: status === "REPROVADO" && original ? original.usuario : cadastro?.usuario,
        status,
        empresa: (cadastro?.empresa || []).map(empresa => ({
          ...empresa,
          conta: { ...empresa.conta, status },
        })),
      };

      return {
        dados: {
          ...dados,
          pendente_aprovacao: (dados.pendente_aprovacao || []).filter(item => item?.usuario?.Id !== usuarioId),
          [destino]: [analisado, ...(dados[destino] || [])],
        },
      };
    });
  };

  render() {
    const { redirectL, redirect, dados, isLoading } = this.state;

    if (redirect) return <Redirect to="/home" />;
    if (redirectL) return <Redirect to="/" />;

    if (isLoading) {
      return (
        <main className="container my-4 px-2 dash">
          <Back />
        </main>
      );
    }

    if (!dados) {
      return (
        <main className="container my-4 px-2 dash">
          <Back />
          <div className="alert alert-danger text-center my-5">Não foi possível carregar os dados.</div>
        </main>
      );
    }

    const menuOptions = [
      {
        id: 1,
        label: "Pendente Aprovação",
        component: <Pendente payload={dados?.pendente_aprovacao} onAnalisado={this.handleCadastroAnalisado} />,
        disabled: false,
      },
      {
        id: 2,
        label: "Aprovados",
        component: <Aprovados payload={dados?.aprovado} />,
        disabled: false,
      },
      {
        id: 3,
        label: "Reprovados",
        component: <Reprovados payload={dados?.reprovado} />,
        disabled: false,
      },
    ];

    return (
      <main className="container my-4 px-2 dash">
        <Back />
        <div className="title-container">
          <h1 className="main-title">Gestão de Cadastros</h1>
          <span className="title-shape"></span>
          <span style={{ marginTop: "20px" }}>Aprove ou reprove os novos cadastros realizados no Conecta e consulte cadastros aprovados e reprovados.</span>
        </div>
        <div className="row">
          <div className="col-12">
            <MenuHorizontal
              menuOptions={menuOptions}
              warningFatherFunction={this.warningFather}
              warningFather={true}
              margin={"20px"}
              width={"750px"}
            />
          </div>
        </div>
      </main>
    );
  }
}

export default GestaoCadastro;
